import { Divider, Flex, Text } from '@shared/components';

interface SummaryCardProps {
  title: string;
  summaryItem: {
    itemTitle: string;
    itemValue: number;
    itemPercent?: number;
  }[];
}

export default function SummaryCard(props: Readonly<SummaryCardProps>) {
  const { title, summaryItem } = props;

  return (
    <Flex
      sx={(theme) => ({
        justifyContent: 'center',
        gap: theme.spacing(3),
        borderRadius: theme.spacing(2),
        padding: theme.spacing(3, 4),
        flexDirection: 'column',
        width: '100%',
        backgroundColor: theme.palette.primary.lighter,
      })}
    >
      <Text variant='body2Semibold'>{title}</Text>
      <Flex sx={(theme) => ({ gap: theme.spacing(4) })}>
        {summaryItem.map((item, index) => (
          <Flex
            key={item.itemTitle}
            sx={(theme) => ({ gap: theme.spacing(4), alignItems: 'center', width: '100%' })}
          >
            <Flex
              sx={(theme) => ({
                flexDirection: 'column',
                gap: theme.spacing(0.5),
                width: '100%',
              })}
            >
              <Text
                variant='body2'
                sx={{ color: (theme) => theme.palette.text.secondary, minWidth: '81px' }}
              >
                {item.itemTitle}
              </Text>
              <Text variant='h5'>{item.itemValue} ข้อ</Text>
              <Text variant='caption' sx={{ color: (theme) => theme.palette.text.secondary }}>
                ({item.itemPercent}%)
              </Text>
            </Flex>
            {index === summaryItem.length - 1 ? null : (
              <Divider
                orientation='vertical'
                flexItem
                sx={{ height: '24px', alignSelf: 'center' }}
              />
            )}
          </Flex>
        ))}
      </Flex>
    </Flex>
  );
}
